{
  // additional event listener needed for the form toggle which lives outside the vue app 
  var changeStoreButton = document.getElementById('job-listings-search-change-store-button')
  if(changeStoreButton) {
    changeStoreButton.addEventListener("click", function(event){
      document.querySelector('#job-listings-search--form-wrapper').style.display = 'none'
      document.querySelector('.job-listings-search').style.display = 'block'
      document.querySelector('#job-listings-search--announcement').focus()
    })
  }
}

